import styled from 'styled-components';

export const TabsContainer = styled.div`
  padding: 0 20px;
  border-bottom: 1px solid #e5e5ea;
  margin-bottom: 20px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px 20px 24px;
`;

export const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 450px;
  overflow-y: auto;
  padding-right: 6px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
    border-radius: 4px;
  }
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  background-color: #ffffff;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;

  &:hover {
    border-color: #d0d0d5;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  }

  .label-col {
    display: flex;
    align-items: center;
    flex: 1;
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .inputs-wrapper {
    display: flex;
    gap: 16px;
  }

  .input-col {
    width: 150px;

    label {
      display: block;
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 6px;
      color: #8e8e93;
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;

    .label-col {
      width: 100%;
      border-bottom: 1px solid #f2f2f7;
      padding-bottom: 12px;
      margin-bottom: 12px;
    }

    .inputs-wrapper {
      width: 100%;
      justify-content: space-between;
    }

    .input-col {
      flex: 1;
      width: auto;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: #fcfcfc;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const ImageUploadContainer = styled.div`
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  color: #8c8c8c;
  font-size: 13px;
  font-weight: 500;
  cursor: default;

  svg {
    color: #bfbfbf;
    margin-bottom: 8px;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #8e8e93;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px dashed #e5e5ea;
`;

export const ShowBorderContainer = styled.div`
  margin: 0px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
